import { themes } from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Navigation = styled(m.nav) `
  ${({ themeOption }) => themeOption &&
    css `
      ${themes[themeOption]}
    `}

  position: fixed;
  top: 0;
  left: 0;
  display: block;
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  height: 100%;
  overflow-y: auto;
  padding: 78px 0 0;
  width: 100%;
  z-index: ${Layers.NavigationMobile};
`;
const NavigationList = styled.ul `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 0;
`;
const NavigationItem = styled(m.li) `
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0;

  & + & {
    margin-top: 24px;
  }
`;
const NavigationLink = styled.a `
  position: relative;
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.gotham.regular};
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  text-decoration: none;

  &:focus,
  &:hover {
    outline: none;
    text-decoration: underline;
  }
`;
const NavigationIcon = styled(m.span) `
  position: absolute;
  top: 50%;
  right: 0;
  display: block;
  height: 15px;
  width: 15px;

  > svg {
    display: block;
    height: 15px;
    width: 15px;
  }
`;
const ChildList = styled(m.ul) `
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;
const ChildItem = styled.div `
  display: block;
  margin: 24px 0 0;
`;
const ChildLink = styled.a `
  display: block;
  color: currentColor;
  ${fonts.gotham.regular};
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  text-decoration: none;

  &:focus,
  &:hover {
    outline: none;
    text-decoration: underline;
  }
`;
const CtaWrapper = styled.li `
  margin-top: 48px;
`;
export default {
    ChildItem,
    ChildLink,
    ChildList,
    CtaWrapper,
    Navigation,
    NavigationIcon,
    NavigationItem,
    NavigationLink,
    NavigationList,
};
